<template>
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <spinner v-show="!isLoaded"></spinner>
      <card v-show="isLoaded" card-body-classes="table-full-width" no-footer-line>
        <h4 v-if="metadata.id === undefined" slot="header" class="card-title">Création d'une métadata</h4>
        <h4 v-if="metadata.id !== undefined" slot="header" class="card-title">Metadata : {{ metadata.name }}</h4>
        <div slot="header" class="col-12 text-right" style="margin-bottom: 10px; margin-top: -50px">
          <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="backToList()">
            <span><i class="fas fa-arrow-circle-left mr-2"></i> Retour</span>
          </n-button>
        </div>
        <div class="mr-4 ml-4 mb-4">
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"></div>
          <form ref="command_form" @submit.prevent="save()">

            <!-- Mon formulaire de création de métadonnées -->
            <div class="row">
              <div class="col-lg-3 ml-auto">
                <label class="input-label">Nom</label>
                <fg-input placeholder="Lecteur Badge" autocomplete="off" name="name" v-validate="'required'" :error="errors.first('name')"
                          v-model="metadata.name" style="margin-bottom: 28px" addon-left-icon="now-ui-icons shopping_tag-content"/>
              </div>
              <div class="col-lg-3">
                <label class="input-label">Phase</label>
                <fg-input class="select" style="margin-bottom: 28px" name="phase" v-model="metadata.phase" v-validate="'required'">
                  <el-select :class="errors.first('phase') ? 'has-error':''"  id="phase" placeholder="Choisir une phase" v-model="metadata.phase" filterable>
                    <el-option v-for="phase in phase_options" :key="phase.id" :label="phase.label" :value="phase.id"></el-option>
                  </el-select>
                  <slot name="helpBlock">
                    <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'" v-if="errors.first('phase')">
                      {{ errors.first('phase') }}
                    </div>
                  </slot>
                </fg-input>
              </div>


              <div class="col-lg-3">
                <label class="input-label">Validation</label>
                <fg-input class="select" style="margin-bottom: 28px" name="required" v-model="required" v-validate="'required'">
                  <el-select :class="errors.first('required') ? 'has-error':''"  id="required" placeholder="Choisir une règle de validation" v-model="required" filterable>
                    <el-option v-for="option in validation_options" :key="option.id" :label="option.label" :value="option.value"></el-option>
                  </el-select>
                  <slot name="helpBlock">
                    <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'" v-if="errors.first('required')">
                      {{ errors.first('required') }}
                    </div>
                  </slot>
                </fg-input>
              </div>


              <div class="col-lg-3 mr-auto">
                <label class="input-label">Interface</label>
                <fg-input class="select" style="margin-bottom: 28px" name="type" v-model="metadata.type" v-validate="'required'">
                  <el-select :class="errors.first('type') ? 'has-error':''"  id="type" placeholder="Choisir une interface" v-model="metadata.type" filterable>
                    <el-option v-for="user_interface in user_interface_options" :key="user_interface.id" :label="user_interface.label" :value="user_interface.id"></el-option>
                  </el-select>
                  <slot name="helpBlock">
                    <div class="text-danger invalid-feedback" style="display: block" :class="'mt-2'" v-if="errors.first('type')">
                      {{ errors.first('type') }}
                    </div>
                  </slot>
                </fg-input>
              </div>
            </div>
            <hr v-if="metadata.type !== '' && metadata.type !== 'Datetime'" class="solid">

            <!-- Pour un menu déroulant -->
            <div v-if="metadata.type === 'select'" class="row">
              <div class="col-12 text-center">
                <h5>Liste des options du menu déroulant</h5>
              </div>
              <div class="col-lg-12">
                <div class="row"  v-for="(option, index) in select_options" :key="index">


                  <div class="col-lg-3 ml-auto">
                    <div class="row">
                      <div class="col-10">
                        <label class="input-label">Option {{index+1}}</label>
                        <fg-input placeholder="Option 1" autocomplete="off" :name="'option_'+(index+1)" v-validate="'required'" :error="errors.first('option_'+(index+1))"
                                  v-model="select_options[index].label" style="margin-bottom: 28px" addon-left-icon="now-ui-icons shopping_tag-content"/>
                      </div>
                      <div class="col-2 text-center">
                        <n-button  type="primary" class="btn btn-sm btn-primary remove-option" @click.native="removeSelectOption(index)">
                          <span><i class="fas fa-trash"></i></span>
                        </n-button>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 mr-auto">
                    <label class="input-label">Dépendance</label>
                    <fg-input class="select" style="margin-bottom: 28px" name="dependence" v-model="select_options[index].dependencies">
                      <el-select id="dependence" placeholder="Métadonnées dépendante" v-model="select_options[index].dependencies" multiple collapse-tags filterable>
                        <el-option v-for="(dependence, dependence_index) in dependencies_options" :key="dependence_index" :label="dependence.label" :value="dependence.label"></el-option>
                      </el-select>
                    </fg-input>
                  </div>


                </div>
              </div>

              <div class="col-lg-12 text-center">
                <n-button  type="primary" class="btn btn-sm btn-primary" @click.native="addSelectOption()">
                  <span><i class="fas fa-plus"></i></span>
                </n-button>
              </div>
            </div>

            <!-- Pour un champs de nombre -->
            <div v-if="metadata.type === 'Int'" class="row">
              <div class="col-lg-3 ml-auto">
                <label class="input-label" style="margin-left: 65px;">Taille min</label>
                <number-input @update:modelValue="updatemodelValue($event, 'min_number')" :model-value="min_number" inline center controls :min="0" :max="max_number"></number-input>
              </div>
              <div class="col-lg-3 mr-auto">
                <label class="input-label" style="margin-left: 65px;">Taille max</label>
                <number-input @update:modelValue="updatemodelValue($event, 'max_number')" :model-value="max_number" inline center controls :min="min_number" :max="255"></number-input>
              </div>
            </div>

            <!-- Pour un champ de date ( Rien de spécifique) -->

            <!-- Pour une chaine de caractère -->
            <div v-if="metadata.type === 'String'" class="row">
              <div class="col-lg-3 ml-auto">
                <label class="input-label" style="margin-left: 55px;">Longueur min</label>
                <number-input @update:modelValue="updatemodelValue($event, 'min_string')" :model-value="min_string" inline center controls :min="0" :max="max_string"></number-input>
              </div>
              <div class="col-lg-3 mr-auto">
                <label class="input-label" style="margin-left: 55px;">Longueur max</label>
                <number-input @update:modelValue="updatemodelValue($event, 'max_string')" :model-value="max_string" inline center controls :min="min_string" :max="255"></number-input>
              </div>
            </div>

            <div class="row">
              <n-button type="primary" class="btn btn-sm btn-primary mr-auto ml-auto mt-4" @click.native="save()">
                <span> Enregistrer </span>
              </n-button>
            </div>
          </form>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { Select, Option } from 'element-ui'
import Spinner from "../../../components/Spinner/Circle";
import Form from "vform";
import NumberInput from "../../../components/Inputs/NumberInput";

export default {
  name: "MetadataForm",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    NumberInput,
    Spinner,
  },
  data() {
    return {
      isLoaded: false,

      min_string: 0,
      max_string: 10,
      min_number: 0,
      max_number: 10,
      required: '',
      validation_options: [
        {label: 'Obligatoire', value: 'required'},
        {label: 'Non Obligatoire', value: 'not required'},
      ],

      dependencies_options: [],

      select_options: [
        {label: 'Option 1', dependencies: []},
        {label: 'Option 2', dependencies: []},
        {label: 'Option 3', dependencies: []},
        {label: 'Option 4', dependencies: []},
      ],

      phase_options: [
        {label: 'CREATION', id: 'CREATION'},
        {label: 'PREPARATION', id: 'PREPARATION'},
      ],

      user_interface_options: [
        {label: 'Menu déroulant', id:'select'},
        {label: 'Champs de Nombre', id:'Int'},
        {label: 'Champs de Date', id:'Datetime'},
        {label: 'Chaine de Caractères', id:'String'},
      ],

      metadata: new Form({
        name: '',
        phase: '',
        type: '',
        options: '',
      })
    };
  },
  mounted() {
    this.axios.get(process.env.VUE_APP_API_BASE_URL+`metadata/list`).catch(error => {
      this.$notify({message: "Une erreur est survenue lors du chargement de la liste des métadonnées", type: 'danger', verticalAlign: 'bottom'})
    }).then( response => {
      response.data.forEach((metadata, index) => {
        this.dependencies_options.push({label: metadata.name, id: metadata.name})
      })
      this.isLoaded = true
    })

    if (this.$route.params.metadata !== undefined){
      var metadata = this.$route.params.metadata

      this.metadata.id = metadata.id
      this.metadata.name = metadata.name
      this.metadata.phase = metadata.phase
      this.metadata.type = metadata.options.type

      if(metadata.options.type === 'select'){
        this.select_options = []
        metadata.options.options.forEach( option => {
          this.select_options.push({label: option.value, dependencies: option.dependencies })
        })
      }

      if(metadata.options.rules.includes("required")){
        this.required = 'required'
      } else {
        this.required = 'not required'
      }

      metadata.options.rules.forEach(rule =>{
        if(rule.includes('min_value:')){
          this.min_number = rule.slice(10)
        } else if(rule.includes('max_value:')){
          this.max_number = rule.slice(10)
        } else if(rule.includes('min:')){
          this.min_string = rule.slice(4)
        } else if(rule.includes('max:')){
          this.max_string = rule.slice(4)
        }
      })
    }
  },
  methods: {
    // Retourne à la liste des article
    backToList() {
      this.$router.push({ name: 'Metadata List' })
    },
    // Enregistre la commande
    save(){
      this.$validator.validateAll().then( value => {
        if (value === true) {

          var options = '"options": ['
          this.select_options.forEach( (option, index) => {

            var dependencies = ""
            option.dependencies.forEach((dependence, dep_index) => {

              if(dep_index === option.dependencies.length-1){
                dependencies = dependencies+'"'+dependence+'"'
              } else {
                dependencies = dependencies+'"'+dependence+'", '
              }

            })
            if(index === this.select_options.length - 1){
              options = options + '{ "value": "'+option.label+'", "dependencies": ['+dependencies+'] }'
              options = options + '],'
            } else {
              options = options + '{ "value": "'+option.label+'", "dependencies": ['+dependencies+'] },'
            }
          })

          var rules = '"rules": ['+(this.required === 'required'? '"required"': '')
          if(this.metadata.type === 'String'){
            if(rules === '"rules": ['){
              rules = rules +' "min:'+this.min_string+'", "max:'+this.max_string+'"'
            } else {
              rules = rules +', "min:'+this.min_string+'", "max:'+this.max_string+'"'
            }
          } else if(this.metadata.type === 'Int'){
            if(rules === '"rules": ['){
              rules = rules +' "min_value:'+this.min_number+'", "max_value:'+this.max_number+'"'
            } else {
              rules = rules +', "min_value:'+this.min_number+'", "max_value:'+this.max_number+'"'
            }
          }
          rules = rules+']'

          this.metadata.options = '{"type": "' + this.metadata.type + '", '

          if(this.metadata.type === 'select'){
            this.metadata.options = this.metadata.options + options + rules +'}'
          } else {
            this.metadata.options = this.metadata.options + rules +'}'
          }

          if(this.metadata.id !== undefined){
            this.metadata.post(process.env.VUE_APP_API_BASE_URL+`metadata/update`).catch(error => {
            }).then( response => {
              // Notification en cas de succès & redirection
              this.$notify({message: 'La métadonées a bien été mis à jour', type: 'success', verticalAlign: 'bottom'})
              this.backToList();
            })
          } else {
            this.metadata.post(process.env.VUE_APP_API_BASE_URL+`metadata/add`).catch(error => {
            }).then( response => {
              // Notification en cas de succès & redirection
              this.$notify({message: 'La métadonnées a bien été enregistrée', type: 'success', verticalAlign: 'bottom'})
              this.backToList();
            })
          }

        }
      })
    },
    // Met a jour le model-value correspondant au field pour le module "Int"
    updatemodelValue: function ($event, field){
      this[field] = $event
    },
    addSelectOption(){
      this.select_options.push({label: 'Option '+(this.select_options.length+1)})
    },
    removeSelectOption(indexToRemove){
      this.select_options.splice(indexToRemove, 1)
    }
  }
}
</script>

<style>
hr.solid {
  border-top: 2px solid #bbb;
  width: 80%;
}

.remove-option {
  margin-left: -70px;
  height: 38px;
  border-top-right-radius: 10px;
  margin-top: 0px;
  border-bottom-right-radius: 10px;
}
</style>
